import React, { useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton, useDisclosure, Button, Box, TableContainer, Table, Thead, Th, Tbody, Tr, Tfoot, Td, Text, Flex
} from '@chakra-ui/react';
import ExportBtn from '../../componunts/ExportBtn/ExportBtn';
import { addDays, format } from 'date-fns';
import { MeetingInfo } from '../../request';

//this component displays the complete details of meetings held by a bdm
//this component receives userID, Date(which was selected on HeldMeetings.jsx), Total(total time meetings done)

const ViewModal = ({ userID, date, total }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [userInfo, setUserInfo] = useState([])


    const OpenModal = async () => {

        try {
            // console.log(userID, date);
            let data = await MeetingInfo(userID, date);
            if (data.status === 200) {
                // console.log(data.data.list)
                setUserInfo(data.data.list)
                onOpen()
            }
        } catch (err) {
            console.log(err)
        }

    };



    const handeltime = (time) => {
        let val = time.split(' ');
        //    console.log(val[1])
        // console.log({ val })
        return val[1]
    };

    //     function getTimeDifference(time1, time2) {
    //    //time1>time2
    //         const date1 = new Date(time1);
    //         const date2 = new Date(time2);

    //         const timeDifferenceMilliseconds = date1-date2;

    //         const hoursDiff = Math.floor(timeDifferenceMilliseconds / 3600000);
    //         const minutesDiff = Math.floor((timeDifferenceMilliseconds % 3600000) / 60000);
    //         const secondsDiff = Math.floor((timeDifferenceMilliseconds % 60000) / 1000);

    //         console.log(hoursDiff,minutesDiff,secondsDiff)

    //       };

    function handleCreatedAt(date){
        let dt = date.split(' ');
        let ans = dt[0]+ '  ' +convertToIST(date);
        return ans;
    }


    function secondsToHMS(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;

        const formattedHours = String(hours).padStart(2, '0');
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(remainingSeconds).padStart(2, '0');

        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
    };


    const convertToIST = (utcTime) => {
        const utcDate = new Date(utcTime.replace(' ', 'T') + 'Z');
        const istTime = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Asia/Kolkata',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: true,
        }).format(utcDate);
        // console.log({ istTime })
        return istTime
    };

    const getDuration = (Date1, Date2) => {
        // Define two dates
        const date1 = new Date(Date1);
        const date2 = new Date(Date2);

        // Calculate the time difference in milliseconds
        const timeDifference = Math.abs(date1.valueOf() - date2.valueOf());

        // Convert milliseconds to seconds
        const secondsDifference = timeDifference / 1000;

        // console.log( secondsDifference);
        let res = secondsToHMS(secondsDifference)
        // console.log({res})
        return res;
    }

//this component initially displays a View button as in HeldMeeting we are just importing this component at the place of View Button
//so a View button is displayed, then onclick a fucntion is executed which, opens the modal and uses the UserID, Date to load data of that user and sets in a state
//so we map over this info and use a table to display the data.
//the functions created in this component are for formatting the date according to our requirments etc


    return (
        <>
            <Button
                bg='teal.100'
                size='sm'
                onClick={() => OpenModal()}
                key='full'
            >View</Button>

            <Modal borderRadius='3px' onClose={onClose} size={{ base: '100%', md: '7xl' }} isOpen={isOpen}>
                <ModalOverlay />
                <ModalContent w={{ base: "90%", md: "90%", lg: "90%" }} h="78vh">
                    <ModalHeader borderTopRadius='3px' bg='teal.300'>Details for {date}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {
                            userInfo && <Box p={{ base: '0px', md: '10px' }} >
                                <Flex gap='20px' fontSize='13px'>
                                    <Text mb='10px'>Employee Name : {userInfo.length > 0 && userInfo[0].assignedUserName}</Text>
                                    <Text mb='10px'>Employee ID : {userID}</Text>
                                </Flex>
                                <TableContainer border='1px solid teal' h='19rem' overflowY='scroll'>
                                    <Table >
                                        <Thead>
                                            <Tr bg='teal.100'>
                                                <Th>Created At</Th>
                                                <Th>Location</Th>
                                                <Th>Contact</Th>
                                                <Th>Checkin Time</Th>
                                                <Th>checkout Time</Th>
                                                <Th>Type</Th>
                                                <Th>Total Meeting Hrs</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {userInfo.map((ele, index) =>

                                                <Tr p='5px' m='auto' key={ele.id}
                                                    fontSize='13px'
                                                //bg={index%2 !==0 ? 'teal.100':''}
                                                >
                                                    <Td textAlign='left'>{ele.createdAt ? handleCreatedAt(ele.createdAt) : '--'}</Td>
                                                    <Td textAlign='left'>{ele.accountName}</Td>
                                                    <Td textAlign='left'>{ele.cContactName }</Td>
                                                    <Td textAlign='center'>{ele.cCheckIn ? convertToIST(ele.cCheckIn) : '--'}</Td>
                                                    <Td textAlign='center'>{ele.cCheckOut ? convertToIST(ele?.cCheckOut) : '--'}</Td>
                                                    {/* <Td>{convertToIST(ele.checkintime)}</Td> */}
                                                    {/* <Td>{getTimeDifference(ele.checkouttime,ele.checkintime)}</Td> */}
                                                    <Td textAlign='center'>{ele?.cType}</Td>
                                                    {/* <Td textAlign='center'>{secondsToHMS(ele?.duration)}</Td> */}
                                                    <Td textAlign='center'>{ele.cCheckIn && ele.cCheckOut ? getDuration(ele.cCheckIn, ele.cCheckOut) :'--'
                                                    }</Td>

                                                </Tr>

                                            )}
                                        </Tbody>
                                        <Tfoot>
                                            <Tr fontWeight='bold'>
                                                <Th></Th>
                                                <Th></Th>
                                                <Th></Th>
                                                <Th color='black' textAlign='center' fontWeight='bold'>Total</Th>
                                                <Th color='black' fontWeight='bold' textAlign='center'>{total}</Th>
                                            </Tr>
                                        </Tfoot>
                                    </Table>
                                </TableContainer>
                            </Box>
                        }
                    </ModalBody>

                    <Flex justifyContent="center" mt="10px" mb='20px'>
                        <ExportBtn w='150px' m='auto' data={userInfo} filename={`${format(new Date(), 'dd-mm-yyyy').toString()}-report123.csv`} />
                    </Flex>
                    <Button w='150px' m='auto' mb='20px' bg='teal.200' onClick={onClose}>Close</Button>

                </ModalContent>
            </Modal>
        </>
    )
}

export default ViewModal;